import { useMediaQuery } from '@mui/material';

const usePrefersReducedMotion = () =>
  useMediaQuery('(prefers-reduced-motion: reduce)', { noSsr: true });

export default usePrefersReducedMotion;
